<template>
  <div>
    <el-dialog :visible.sync="showSetDomain">
      <el-form :model="dataSet">
        <el-form-item label="域名" ><el-input v-model="dataSet.domain" size="mini" style="width: 600px;"></el-input></el-form-item>
        <el-form-item label="状态">
          <el-select v-model="dataSet.valid" label="状态">
            <el-option value = 1 label="开">开</el-option>
            <el-option value = 0 label="关">关</el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="success" size="mini" @click="subDomain()">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-button size="mini"  type="info"  @click="showDiv()">添加</el-button>

    <el-table :data="domainList" v-loading="loading">
      <el-table-column prop="id" label="ID" />
      <el-table-column prop="domain" label="域名" />
      <el-table-column prop="valid"  label="状态" >
        <template slot-scope="scope">
          关
          <el-switch size="mini"
                     v-model="scope.row.valid"
                     :active-value="1"
                     :inactive-value="0"
                     @change="handleSetValid(scope.row.domain, scope.$index)"
          />
          开
        </template>
      </el-table-column>
      <el-table-column prop="time" width="150px" label="时间" />
    </el-table>
    <!-- <page-bar :currentPageCount="domainList.length" @page-changed="loadData"></page-bar> -->
  </div>
</template>

<script>
  import request from "../../api/request";

  export default {
    name: "DomainList",
    data() {
      return {
        loading: true,
        showSetDomain: false,
        domainList:[],
        dataSet:{},
        searchData: {},
        filter: {}
      };
    },
    created() {
      this.loadData();
    },
    methods: {
      subDomain: function() {
//      console.log(this.dataSet.user_id);

        request.front
                .post("cms_domain_set", {
                  domain: this.dataSet.domain,
                  valid: this.dataSet.valid == 1 ? true : false,
                })
                .then(() => {
                  this.$message.success("提交成功");
                })
                .finally(() => {
                  this.showSeshowSetDomaintVcard = false;
                  this.dataSet = {};
                  location.reload();
                });
      },

      async loadData() {
        request.front
                .post("cms_domain_list", {
                })
                .then(r => {
                  this.domainList = r.data.list;
                  this.loading = false;
                });
      },
      showDiv () {
        this.showSetDomain = true
      },
      handleSetValid(domain, index) {
        request.front.post('cms_domain_set', {
          domain: domain,
          valid: this.domainList[index].valid == 1 ? true : false,
        }).then(() => {
          this.$message.success('保存成功')
        }).catch(() => {
          this.$message.error('保存失败')
        })
      }

    }
  };
</script>